import { withInstall } from '@xzx-design/utils'
import _Skeleton from './src/skeleton.tsx'
import _SkeletonAvatar from './src/skeleton-avatar.tsx'
import _SkeletonImage from './src/skeleton-image.tsx'
import _SkeletonParagraph from './src/skeleton-paragraph.tsx'
import _SkeletonTitle from './src/skeleton-title.tsx'

export const Skeleton = withInstall(_Skeleton)
export default Skeleton
export const SkeletonImage = withInstall(_SkeletonImage)
export const SkeletonAvatar = withInstall(_SkeletonAvatar)
export const SkeletonParagraph = withInstall(_SkeletonParagraph)
export const SkeletonTitle = withInstall(_SkeletonTitle)

export * from './src/skeleton'
export * from './src/skeleton-avatar'
export * from './src/skeleton-image'
export * from './src/skeleton-paragraph'
export * from './src/skeleton-title'
export * from './src/types'
